import React, { useState } from 'react';
import Button from '../../components/common/Button';
import FormField from '../../components/common/FormField';
import { MemberDTO } from '../../services/apiClient';
import handleChange from '../../utils/formUtils/handleChange';

interface MemberFormProps {
  initialValues: MemberDTO;
  onSubmit: (data: MemberDTO) => void;
  onCancel: () => void;
}

const MemberForm: React.FC<MemberFormProps> = ({
  initialValues,
  onSubmit,
  onCancel,
}) => {
  const [formData, setFormData] = useState<MemberDTO>(initialValues);

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData); // Pass the updated data back to the parent
  };

  return (
    <form onSubmit={handleFormSubmit}>
      <div className="mb-4">
        <FormField
          id="membershipNumber"
          label="Membership Number"
          type="text"
          value={formData.membershipNumber || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Membership Number"
        />
        <FormField
          id="firstName"
          label="First Name"
          type="text"
          value={formData.firstName || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter First Name"
        />
         <FormField
          id="lastName"
          label="Last Name"
          type="text"
          value={formData.lastName || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Last Name"
        />
        <FormField
          id="email"
          label="Email"
          type="email"
          value={formData.email || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Email"
        />
        <FormField
          id="phone"
          label="Phone"
          type="text"
          value={formData.phone || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Email"
        />
      </div>
      <div className="flex justify-end space-x-4">
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit">Save</Button>
      </div>
    </form>
  );
};

export default MemberForm;
